import React from 'react'
import { DrawerSeeker } from '@ui-seeker/core'

import { isEmpty } from '@ui-seeker/utils'
import { batch, useComputed } from '@preact/signals-react'
import { formData } from '@signals'
import { selectedMappingId } from 'Pages/Admin/AdminMapping/@signals'
import AdminMappingDrawerTitle from 'Pages/Admin/AdminMapping/EditDrawer/Title'
import AdminMappingDrawerFooter from 'Pages/Admin/AdminMapping/EditDrawer/Footer'
import AdminMappingDrawerContent from 'Pages/Admin/AdminMapping/EditDrawer/Content'

export default function EditMappingDrawer() {

	const isDataEmpty = useComputed(() => isEmpty(formData.value))

	if (isDataEmpty.value) return null

	return <DrawerSeeker
		isOpen={!isDataEmpty.value}
		controller={() => batch(() => {
			formData.value = {}
			selectedMappingId.value = null
		})}
		title={<AdminMappingDrawerTitle/>}
		customFooter={<AdminMappingDrawerFooter/>}
	>
		<AdminMappingDrawerContent/>
	</DrawerSeeker>

}